import { call, put, takeEvery } from 'redux-saga/effects'
import {
  GET_WORKORDER_ITEMS,
  ADD_WORKORDER_ITEM,
  UPDATE_WORKORDER_ITEM,
  DELETE_WORKORDER_ITEM,
} from './actionTypes'
import {
  getWorkOrderItemsSuccess,
  getWorkOrderItemsFail,
  addWorkOrderItemSuccess,
  addWorkOrderItemFail,
  updateWorkOrderItemSuccess,
  updateWorkOrderItemFail,
  deleteWorkOrderItemSuccess,
  deleteWorkOrderItemFail,
  setWorkOrderItemFieldErrors,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'

// API calls
const fetchWorkOrderItemsApi = () => axiosInstance.get('', { params: { sp: 'usp_GetWorkOrderItems' } })
const addWorkOrderItemApi = (workOrderItem) => axiosInstance.post('', workOrderItem)
const updateWorkOrderItemApi = (workOrderItem) => axiosInstance.post('', workOrderItem)
const deleteWorkOrderItemApi = (id) => axiosInstance.post('', { sp: 'usp_DeleteWorkOrderItems', workOrderItemId: id })

// Sagas
function* getWorkOrderItemsSaga() {
  try {
    const { data } = yield call(fetchWorkOrderItemsApi)
    yield put(getWorkOrderItemsSuccess(data))
  } catch (error) {
    yield put(getWorkOrderItemsFail(error.response?.data || error.message))
  }
}

function* addWorkOrderItemSaga(action) {
  try {
    const { data } = yield call(addWorkOrderItemApi, action.payload)
    yield put(addWorkOrderItemSuccess(data))
    toast.success('Work order item added successfully!')
    yield put({ type: GET_WORKORDER_ITEMS })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setWorkOrderItemFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(addWorkOrderItemFail(error.response?.data || error.message))
    }
  }
}

function* updateWorkOrderItemSaga(action) {
  try {
    const { data } = yield call(updateWorkOrderItemApi, action.payload)
    yield put(updateWorkOrderItemSuccess(data))
    toast.success('Work order item updated successfully!')
    yield put({ type: GET_WORKORDER_ITEMS })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setWorkOrderItemFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(updateWorkOrderItemFail(error.response?.data || error.message))
    }
  }
}

function* deleteWorkOrderItemSaga(action) {
  try {
    yield call(deleteWorkOrderItemApi, action.payload)
    yield put(deleteWorkOrderItemSuccess(action.payload))
    toast.success('Work order item deleted successfully!')
    yield put({ type: GET_WORKORDER_ITEMS })
  } catch (error) {
    yield put(deleteWorkOrderItemFail(error.response?.data || error.message))
  }
}

// Watcher saga
function* workOrderItemSaga() {
  yield takeEvery(GET_WORKORDER_ITEMS, getWorkOrderItemsSaga)
  yield takeEvery(ADD_WORKORDER_ITEM, addWorkOrderItemSaga)
  yield takeEvery(UPDATE_WORKORDER_ITEM, updateWorkOrderItemSaga)
  yield takeEvery(DELETE_WORKORDER_ITEM, deleteWorkOrderItemSaga)
}

export default workOrderItemSaga
